/**
 * DeltaPill — пилюля изменения метрики (стрелка + процент). Рост — синяя,
 * снижение — красная.
 */

import {ChevronDown, ChevronUp} from 'lucide-react';

import {cn} from '@lib/utils';

import {fmtPct} from '../Dashboard.utils';

type DeltaPillProps = {pct: number; negative?: boolean};

export const DeltaPill = ({pct, negative = false}: DeltaPillProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-[3px] rounded-full px-[7px] py-0.5 text-[12.5px] font-semibold',
      negative ? 'bg-[#FBE9E7] text-skr-danger' : 'bg-accent text-primary',
    )}
  >
    {negative ? (
      <ChevronDown className="size-[11px]" strokeWidth={3} />
    ) : (
      <ChevronUp className="size-[11px]" strokeWidth={3} />
    )}
    {fmtPct(pct)}%
  </span>
);
